import { useTranslation as useTranslationReacti18next, TFunction } from "react-i18next";

export type { TFunction };

export default function useTranslation() {
  const { t, i18n } = useTranslationReacti18next();

  return { t, i18n };
}
